module.exports = __webpack_public_path__ + "static/media/gpo2.3d95c14b.jpeg";